// extracted by css-extract-rspack-plugin
export default {"root":"root-GGm5w","arrowRoot":"arrowRoot-3OZAk","body":"body-2FukF","closeButton":"closeButton-F9rle"};